import {Component, input, OnInit, signal} from '@angular/core';
import {MatExpansionPanel} from '@angular/material/expansion';
import {PriceItemsGroup} from '../price-items-group';
import {PriceLogDialogComponent} from '../price-log-dialog/price-log-dialog.component';
import {MatDialog} from '@angular/material/dialog';
import {Inspection} from '../../classes/inspection';
import {MatProgressBar} from "@angular/material/progress-bar";
import {MatFormField, MatInput, MatPrefix} from "@angular/material/input";
import {FormsModule} from "@angular/forms";
import {MatIconButton} from "@angular/material/button";

@Component({
    selector: 'app-prices-edit',
    templateUrl: './prices-edit.component.html',
    styleUrls: ['./prices-edit.component.scss'],
    imports: [
        MatProgressBar,
        MatFormField,
        FormsModule,
        MatInput,
        MatPrefix,
        MatIconButton
    ]
})
export class PricesEditComponent implements OnInit {

    panelIndex = input<number>();

    panel = input<MatExpansionPanel>();

    priceGroup = input<PriceItemsGroup>();

    paintColorKeyVal = input();

    inspections = input<Inspection[]>([]);

    extraCostNames = input();

    readonly show = signal<boolean>(false);

    constructor(public dialog: MatDialog) {
    }

    ngOnInit(): void {
        this.panel().afterExpand.subscribe(() => {
            this.show.update(() => true);
            setTimeout(() => {
                const elem = document.querySelector(`#panel-${this.panelIndex()}-0`) as HTMLInputElement;
                if (elem) {
                    elem.focus();
                }
            });
        });
    }

    openPriceLog(priceId, type, inspectionId) {
        const dialogRef = this.dialog.open(PriceLogDialogComponent, {
            panelClass: 'price-log-dialog',
            data: {priceId, type, inspectionId}
        });
    }

}
